import $ from 'jquery';
import {youtubeVideo} from '../components/youtube.js';
import {playVideo} from '../components/play-video.js';

export function ajaxOwlCarousel() {
    const owlReview = $('.review-slider');

    function initOwlCarousel() {
        owlReview.owlCarousel({
            onInitialized: videoSlide,
            onChanged: videoSlide,
            loop: false,
            nav: true,
            items: 1,
            dots: false,
            navContainer: '.reviews-section__nav',
            navText: ['<svg class="icon icon-owl-arrow"><use xlink:href="/wp-content/themes/brander_custom_theme/assets/images/sprite.svg#owl-left"></use></svg>', '<svg class="icon icon-owl-arrow"><use xlink:href="/wp-content/themes/brander_custom_theme/assets/images/sprite.svg#owl-right"></use></svg>']
        });

        playVideo();
        youtubeVideo();
    }

    function videoSlide(e) {
        const itemVideo = $('.review-slider__video');
        const itemIframe = $('.youtube-slider__file');
        const playButton = $('.play');

        itemVideo.each(function (i, el) {
            if (!el.paused && el.paused != null) {
                el.pause();
            }

            if ($(playButton).hasClass('play-start')) {
                playButton.removeClass('play-start');
            }
        })

        itemIframe.each(function (i, el) {
            const childIframe = $(el).children('.review-slider__iframe');

            if (childIframe) {
                childIframe.each(function (i, el) {
                    el.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
                })
            }
        })

        const currentNumber = $('.review-slider__bottom .counter .counter__current');
        const totalNumber = $('.review-slider__bottom .counter .counter__total');

        currentNumber.text(`${e.item.index + 1}`);
        totalNumber.text(`${e.item.count}`);
    }

    initOwlCarousel();

    owlReview.on('refresh', function () {

        owlReview.trigger('destroy.owl.carousel');

        initOwlCarousel();
    })
}


// WEBPACK FOOTER //
// app/scripts/components/owlReview.js